export default __webpack_public_path__ + "static/talents.administration-ffdaba0c61187cd501568721b4175da6.png";